<template>
  <div class="turn-page">
    <ul>
      <li class="frist pages-fn" @click="(current = 1) && pageGo(current)">首页</li>
      <li
        class="prev pages-fn"
        @click="(current > 1 && current--) && pageGo(current--)"
      >上一页</li>
      <li
        :class="{page:true, active:current == item}"
        v-for="(item, index) in pages"
        @click="pageGo(item)"
      >{{item}}</li>
      <li
        class="next pages-fn"
        @click="(current < pagetotal && current++) &&　pageGo(current++)"
      >下一页</li>
      <li
        class="last pages-fn"
        @click="(current = pagetotal) && pageGo(current)"
      >尾页</li>
    </ul>
  </div>
</template>
<script>
export default {
  name: 'pages',
  props: {
    total: {
      type: Number,
      default: 0
    },
    show: {
      type: Number,
      default: 5
    }
  },
  data: function () {
    return {
      pagetotal: this.total,
      current: 1,
      showItem: this.show
    }
  },
  computed: {
    pages: function() {
      var page = [];
      if (this.current < this.showItem) {
        var i = Math.min(this.showItem, this.pagetotal);
        while (i) {
          page.unshift(i--);
        }
      } else {
        var middle = this.current - Math.floor(this.showItem / 2),
          i = this.showItem;
        if (middle > (this.pagetotal - this.showItem)) {
          middle = (this.pagetotal - this.showItem) + 1
        }
        while (i--) {
          page.push(middle++);
        }
      }
      return page
    }
  },
  watch: {
    total(val) {
      this.pagetotal = val;
    }
  },
  methods: {
    pageGo: function(nums) {
      this.current = nums;
      this.$emit('pageto', this.current)
      if (nums === this.current) return;
    }
  }
}
</script>
<style lang="scss" scoped>
.turn-page {
  text-align: center;
  font-size: 0;
  margin-top: 10px;
}
.turn-page ul li {
    display: inline-block;
    height: 34px;
    font-size: 12px;
    background: #ececec;
    margin: 5px 0 5px 10px;
    background-color: #f8f8f8;
    border-radius: 3px;
    border: 1px solid #e5e5e5;
    line-height: 34px;
    margin: 0 2px;
    text-align: center;
    cursor: pointer;
  }

  .turn-page ul li.pages-fn {
    padding: 0 8px;
  }

  .turn-page ul li.page {
    width: 34px;
  }

  .turn-page ul li:hover {
    border: solid 1px #3b5391;
    background-color: #3b5391;
    color: #fff;
  }

  .turn-page ul li.active {
    border: solid 1px #3b5391;
    background: #3b5391;
    color: #fff !important;
    border-radius: 3px;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/page.vue